
import { Component, Vue, Watch } from "vue-property-decorator";
import SpatialNavigation from "spatial-navigation-js";
import {
  Config,
  EnterToOptions,
  RestrictOptions
} from "@/@types/spatial-navigation-js/types";
import Sidebar from "@/components/sidebar/Sidebar.vue";
import Alert from "@/components/alert/Alert.vue";
import { RouteName } from "@/router/types";
import apiStorageInterface, {
  defaultProviderData
} from "@/services/apiStorageInterface";
import { ProviderData } from "@/services/apiService/api.types";

@Component({
  components: { Sidebar, Alert }
})
export default class App extends Vue {
  providerData: ProviderData = defaultProviderData;
  async mounted(): Promise<void> {
    window.addEventListener("load", () => {
      const defaultConfig: Config = {
        selector: ".focusable",
        straightOnly: true,
        rememberSource: false,
        disabled: false,
        defaultElement: "",
        enterTo: EnterToOptions.Empty,
        leaveFor: null,
        restrict: RestrictOptions.SelfFirst,
        tabIndexIgnoreList: "a, select, textarea, iframe",
        navigableFilter: null
      };
      SpatialNavigation.init();
      SpatialNavigation.add(defaultConfig);

      SpatialNavigation.add({
        selector: ".playerControls .focusable",
        defaultElement: "#playPause"
      });

      SpatialNavigation.add({
        selector: "#carouselControls .focusable",
        defaultElement: "#liveHeading"
      });

      SpatialNavigation.add({
        selector: ".sidebar .focusable"
      });
      // Make the *currently existing* navigable elements focusable.
      SpatialNavigation.makeFocusable();

      // Focus the first navigable element.
      SpatialNavigation.focus();
    });

    //making sure not to lose color scheme when reloading pages
    if (this.loadProviderData) {
      this.providerData = await apiStorageInterface.fetchProviderData(true);
    }
  }

  get isStandardLayout(): boolean {
    return ![RouteName.Login, RouteName.Player].includes(
      this.$route.name as RouteName
    );
  }

  get loadProviderData(): boolean {
    return RouteName.Login !== this.$route.name;
  }

  get dynamicBgImage(): string {
    //set bg image as default one if color scheme does not come with one, or we are on the login page
    if (
      !this.providerData.colorScheme.media ||
      this.$route.name === RouteName.Login
    ) {
      if (this.isStandardLayout) {
        return (
          "linear-gradient(180deg, rgba(1,1,1,1) 0%, rgba(0,0,0,0.5) 51%, rgba(24,24,24,1) 93%), url(" +
          this.bgImage +
          ")"
        );
      }

      return "url(" + this.bgImage + ")";
    }

    if (this.isStandardLayout) {
      return (
        "linear-gradient(180deg, rgba(1,1,1,1) 0%, rgba(0,0,0,0.5) 51%, rgba(24,24,24,1) 93%), url(" +
        this.providerData.colorScheme.media.url +
        ")"
      );
    }

    return "url(" + this.providerData.colorScheme.media.url + ")";
  }

  get bgImage(): string {
    return require("/src/assets/images/top_section_bcg.jpg");
  }

  get styleObject(): Record<string, string> | undefined {
    if (this.providerData) {
      return {
        "--accent-color": this.providerData.colorScheme.accent,
        "--main-light": this.providerData.colorScheme.mainLight,
        "--main-dark": this.providerData.colorScheme.mainDark
      };
    }

    return undefined;
  }

  @Watch("loadProviderData")
  async handleProviderData(newVal: boolean): Promise<void> {
    //initial setting of color scheme
    if (newVal) {
      this.providerData = await apiStorageInterface.fetchProviderData(true);
    }
  }
}
